module.exports = __webpack_public_path__ + "img/rectangle-26@1x.8d9647f7.png";